import { JsonObject, JsonProperty } from 'json2typescript';

import { DateConverter } from '@shared/utils/date.converter';

@JsonObject('documents')
export class DocumentItem {
  @JsonProperty('referenceId', String, true)
  public referenceId = '';

  @JsonProperty('dateUpload', DateConverter, true)
  public dateUpload?: Date = undefined;

  @JsonProperty('uploadedAttachmentGroup', String, true)
  public uploadedAttachmentGroup = '';

  @JsonProperty('filename', String, true)
  public filename = '';

  @JsonProperty('type', String, true)
  public type = '';

  @JsonProperty('typeDocument', String, true)
  public typeDocument = '';

  public path?: string = undefined;

  public typology?: string = undefined;
}
